import { useEffect, useState } from 'react';

/** True zodra de viewport smaller is dan `bp` (default 900px). */
export function useIsMobile(bp = 900): boolean {
  const [m, setM] = useState(typeof window !== 'undefined' && window.innerWidth <= bp);
  useEffect(() => {
    const on = () => setM(window.innerWidth <= bp);
    on();
    window.addEventListener('resize', on);
    return () => window.removeEventListener('resize', on);
  }, [bp]);
  return m;
}
